export enum InventoryItemOutcome {
  Consolidate = "consolidate",
  Liquidate = "liquidate",
  Donate = "donate",
  Destroy = "destroy",
  Restock = "restock",
  ReturnToSender = "return_to_sender",
  Fulfilled = "fulfilled",
}
